import { render, staticRenderFns } from "./productAddImge.vue?vue&type=template&id=5f8dcfd2&scoped=true"
import script from "./productAddImge.vue?vue&type=script&lang=js"
export * from "./productAddImge.vue?vue&type=script&lang=js"
import style0 from "./productAddImge.vue?vue&type=style&index=0&id=5f8dcfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8dcfd2",
  null
  
)

export default component.exports